import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { translate } from 'react-i18next';
import FlatButton from 'material-ui/FlatButton';
import swal from 'sweetalert';
import { Table } from 'react-bootstrap';
import SvgIcon from 'react-icons-kit';
import {notification} from 'react-icons-kit/icomoon/notification';
import moment from 'moment';

var Config = require('../../../config');

class ModalReserved extends Component{
	constructor(props, context) {
		super(props, context);
		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.onSave = this.onSave.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.changeCheck = this.changeCheck.bind(this);
		
		this.state = {
		    show: false,
		    listado:[],
		    check_all:false
		};
	}

	componentDidMount() {
		this.props.onRef(this);
	}

	componentWillUnmount() {
		this.props.onRef(null)
	}

	handleChange(e){
		if(e.target.type === 'checkbox'){
			var list = this.state.listado;

			list.map((l)=>{
				l.check = e.target.checked ? true: false
			});

			this.setState({
				[e.target.name]: e.target.checked ? true: false,
				listado: list
			});
		}
	}

	handleClose() {
		this.setState({ show: false, listado:[],check_all:false});
	}

	handleShow(list) {
		if(list.length > 1){
			list.map((l)=>{
				l.check = false;
			});
		}else{
			list.map((l)=>{
				l.check = true;
			});
		}

		this.setState({show: true, listado:list});
		
	}

	onSave(){
		var units = [];
		
		
		this.state.listado.map((l)=>{
			if(l.check){
				units.push(l.unit_id);
			}
			
		});
		
		if(units.length > 0){
			this.props.waiting.handleShow('Retirando reserva');
			fetch(Config.default.apiGateway.URL+'unit_reserved/remove_by_units',{
				method:'POST',
				body:JSON.stringify(units),
				headers: new Headers({
					'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
					'Accept'		: 'application/json',
					'Content-Type'	: 'application/json'
				})
			}).then(res => {
				this.props.waiting.handleClose();
				if(res.ok){
					return res.json();
				}else{
					res.text().then((msg)=>{
						swal('Error', msg, 'error');
					});
				}
			}).then(response => {
				if(response !== undefined){
					var incidents = this.props.getDataForm();
					this.props.discard(incidents.units);
					this.handleClose();
				}
			})
		}else{
			swal('Error', 'Debe seleccionar por lo menos una unidad', 'error');
		}
			
	}

	changeCheck(e, i){
		var list = this.state.listado;

		list.map((l, j)=>{
			if(i === j){
				l.check = e.target.checked ? true : false
			}
		});

		this.setState({listado: list});
	}
	
	render(){
		const { t } = this.props;
		return(
			<div>
			<Modal bsSize={"lg"} show={this.state.show} onHide={this.handleClose}>
		       	<Modal.Header closeButton>
		        	<Modal.Title style={{textAlign:'center'}}>
		        		<SvgIcon size={90} icon={notification} style={{color:'orange'}}/>
		        	</Modal.Title>
		        </Modal.Header>
		        <Modal.Body >
		        	<div className="row" style={{paddingLeft:"10px",paddingRight:"10px"}}>
		        		{this.state.listado.length > 1 ? 
		        			<div className="col-xs-12">
			        			<h4 style={{textAlign:'center', color:'orange'}}>
			        				Las siguientes unidades se encuentran reservadas
			        			</h4>		   
			        			<h5 style={{textAlign:'center', color:'orange'}}>{'¿Desea retirar la reserva y continuar con el proceso de baja?'}</h5>		 

			        			<div className="col-xs-12">
		        					<Table responsive hover>
		        						<thead>
		        							<tr>
		        								<th>
		        									<input type="checkbox" name="check_all" id="check_all" value={this.state.check_all}
		        										onChange={this.handleChange} checked={this.state.check_all} />
		        								</th>
		        								<th>Unidad</th>
		        								<th>Paciente</th>
		        							</tr>
		        						</thead>
		        						<tbody>
		        							{this.state.listado.map((l, i)=>(
		        								<tr key={i}>
		        									<td>
			        									<input type="checkbox" value={l.check}
			        										onChange={(e)=>this.changeCheck(e, i)} checked={l.check} />
			        								</td>
			        								<td>{l.unit_number}</td>
			        								<td>{l.patients}</td>
		        								</tr>
		        							))}
		        						</tbody>
		        					</Table>
		        				</div>  
			        		</div>
			        	:this.state.listado.map((l, i)=>(
							<div className="col-xs-12" key={i}>
								<h4 style={{textAlign:'center', color:'orange'}}>
			        				La unidad {l.unit_number} esta reservada para el paciente {l.patients}
			        			</h4>		   
			        			<h5 style={{textAlign:'center', color:'orange'}}>{'¿Desea retirar la reserva y continuar con el proceso de baja?'}</h5>		   
			        		</div>
			        	))}
		        		
				    </div>
		        </Modal.Body>
		        <Modal.Footer>
		        	<FlatButton primary={true} label={'Continuar'} onClick={this.onSave}  />
		        	<FlatButton primary={true} label={'Cancelar'} onClick={this.handleClose} />
		        </Modal.Footer>
	      	</Modal>
	      	</div>
		);
	}
}

export default translate('translations')(ModalReserved);